module.exports = __webpack_public_path__ + "static/ARP-a32bef0b5736279322532a633fc30d74.svg";